import React from 'react'
import EPCLink from "../../component/Asset/EPCLink";
import TransactionItemWrongWorkflow from '../../transaction/component/TransactionItemWrongWorkflow';
import {dayMonthYearAtTime} from "../../utils/dates";

class TransactionItemGrid {

  columns = [
    {
      Header: 'EPC',
      Cell: row => <EPCLink epc={row.original.epc}/>
    },
    {
      Header: 'Data',
      Cell: row => row.original.readDate && dayMonthYearAtTime(row.original.readDate)
    },
    {
      Header: 'Status',
      Cell: row => `${row.original.status}${row.original.statusReason ? ` - ${row.original.statusReason}` : ''}`
    },
    {
      Header: 'Ponto de Leitura',
      Cell: row => row.original.readPoint && row.original.readPoint.friendlyName
    },
    {
      Header: 'Status do Fluxo',
      style: { whiteSpace: 'unset' },
      Cell: row => <TransactionItemWrongWorkflow wrongWorkflowData={row.original && row.original.wrongWorkFlow}/>
    }
  ];

  endpoint = (transactionId, productTypeId) => {
    const params = new URLSearchParams({})

    transactionId && params.append('transactionId', transactionId)
    productTypeId && params.append('productTypeId', productTypeId)

    return `ton/v1/transaction-items?${params.toString()}`
  }
}

export default TransactionItemGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/TransactionItemGrid.js